/**
 * @flow
 * @relayHash 433d35eee8f3048e8a7a44a2c8bb0800
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMpTemplatePlaylistSongInput = {
  clientMutationId?: ?string,
  id: string,
};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationVariables = {|
  input: DeleteMpTemplatePlaylistSongInput
|};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationResponse = {|
  +deleteMpTemplatePlaylistSong: ?{|
    +deletedMpTemplatePlaylistSongId: ?string,
    +mp_template_playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |},
      +num_songs: ?number,
    |},
  |}
|};
export type MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation = {|
  variables: MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationVariables,
  response: MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutationResponse,
|};
*/


/*
mutation MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation(
  $input: DeleteMpTemplatePlaylistSongInput!
) {
  deleteMpTemplatePlaylistSong(input: $input) {
    deletedMpTemplatePlaylistSongId
    mp_template_playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      num_songs
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMpTemplatePlaylistSongInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeleteMpTemplatePlaylistSongInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deletedMpTemplatePlaylistSongId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "num_songs",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation",
  "id": null,
  "text": "mutation MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation(\n  $input: DeleteMpTemplatePlaylistSongInput!\n) {\n  deleteMpTemplatePlaylistSong(input: $input) {\n    deletedMpTemplatePlaylistSongId\n    mp_template_playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      num_songs\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteMpTemplatePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteMpTemplatePlaylistSongPayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplatePlaylist",
            "plural": false,
            "selections": [
              v4,
              v5
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteMpTemplatePlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeleteMpTemplatePlaylistSongPayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplatePlaylist",
            "plural": false,
            "selections": [
              v4,
              v5,
              v3
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e41bb4b370229e518dc55259d7c21170';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/__generated__/MpTemplatePlaylist_deleteMpTemplatePlaylistSongMutation.graphql.js